import { render, staticRenderFns } from "./conteudo.vue?vue&type=template&id=c68080ac"
import script from "./conteudo.vue?vue&type=script&lang=js"
export * from "./conteudo.vue?vue&type=script&lang=js"
import style0 from "./conteudo.vue?vue&type=style&index=0&id=c68080ac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports